import color_palette_list from '../gb-helper/color_palette';
import block_icons from '../icons/marketing_button';
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import IconPicker  from './icon-picker/index';
const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    BlockAlignmentToolbar,
    RichText } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, SelectControl, RangeControl, Dashicon,ColorPalette, ColorIndicator,
    Card, CardBody, Button, TabPanel,__experimentalGradientPicker } = wp.components;

registerBlockType('blocksbakery/marketing-button', {
    title: __('Marketing Button', 'blocks-bakery'),
    description: __(
        'You can create trendy CTA with the help of marketing button in blocks. This button is especially used to attract visitors with the text that is conversion oriented and a button with many customization options.',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: block_icons.marketing,
    keywords: [
        __('button', 'blocks-bakery'),
        __('marketing', 'blocks-bakery'),
        __('social', 'blocks-bakery')
    ],

    supports: {
        html: false
    },
    attributes: {
        // editor setting
        title_tag: {
            type: 'html',
            default: 'h4'
        },
        iconDisp1: {
            type: 'string',
            default: 'block'
        },
        iconDisp2: {
            type: 'string',
            default: 'none'
        },
        title_value: {
            type: "string",
            default: 'Subscribe Now'
        },
        paragraph_value: {
            type: "string",
            default: 'Get access to Premium Features for FREE for a year!'
        },

        // Border
        select_border: {
            type: 'string',
            default: "solid"
        },
        border_width: {
            type: 'number',
            default: 1
        },
        border_radius: {
            type: 'number',
            default:0
        },
        border_color: {
            type: 'string',
        },
        border_hover_color: {
            type: 'string',
           
        },

        // background
      
        padding_lf_rh: {
            type: "number",
            default:100
        },
        bg_color: {
            type: 'string',
        },
        bg_color_opacity: {
            type: "number",
            default: 1
        },
        bg_hover_color: {
            type: 'string',
        },
        hover_opacity: {
            type: "number",
            default: 1
        },
        
        // General
        position_icon: {
            type: "string",
            default: 'before'
        },
        position_div: {
            type: "string",
            default: "center"
        },
        icon_selector: {
            type:'string',
            default:'far fa-envelope-open'
        },
        icon_spacing: {
            type: 'number',
            default: 5
        },
        bt_margin: {
            type: 'number',
            default: 0
        },
        url_icon: {
            type: 'string',
            default: "#"
        },
        margin_lf_rh: {
            type: "number",
            default: 0
        },

        // content
        title_size: {
            type: 'number',
        },
        title_font_family: {
            type: 'string',
            default:'ABeeZee'
        },
        title_weight: {
            type: 'string',
            default:'regular'
        },
        title_line_height: {
            type: 'number',
            default:1.5
        },
        description_size: {
            type: 'number',
            default:16     
        },
        description_weight: {
            type: 'string',
            default:'regular'
        },
        description_font_family: {
            type: 'string',
            default:'ABeeZee',
        },
        description_line_height: {
            type: 'number',
            default: 1.5
        },
        bg_content: {
            type: 'string',
            default: 'transparent'
        },
        title_color: {
            type: "string",
        },
        icon_color: {
            type: "string",
        },
        description_color: {
            type: "string",
        },
        hover_title_color: {
            type: "string"
        },
        hover_icon_color: {
            type: "string"
        },
        hover_desc_color: {
            type: "string"
        },
        bg_selctor_type: {
            type: 'string',
        },
        LneHghttitlepx:{
            type:'string',
            default:'em'
        },
        mbdescempx:{
            type:'string',
            default:'px',
        },
        mbdescriptionempx:{
            type:'string',
            default:'em',
        },
        pxemtitlte:{
            type:'string',
            default:'px'
        },
        padding_lrtp:{
            type:"string",
            default:"px"
        },
        padding_topbottom:{
            type:"number",
            default:15

        },
        icon_size:{
            type:"number",
            default:23
        },
        gradient_bg: {
            type: 'string'
        },
        block_alignment: {
            type: 'string',
            default: 'center'
        },
        width_adjust:{
            type: 'string',
            default: 'fit-content'
        }
    },
    getEditWrapperProps: ({ block_alignment }) => {
        if( 'left' === block_alignment || 'right' === block_alignment || 'full' === block_alignment || 'center' === block_alignment || 'wide' === block_alignment ){
            return { 'data-align': block_alignment };
        }
    },
    edit: (props) => {

        var index = font_family_detailed.findIndex(x => x.family === props.attributes.title_font_family);
        var font_weight = font_family_detailed[index].variants
        var font_weight_title_list = []
        for (var i = 0; i < font_weight.length; i++) {
            font_weight_title_list.push({ label: font_weight[i], value: font_weight[i] })
        }

        
        var index_description = font_family_detailed.findIndex(x => x.family === props.attributes.description_font_family);
        var font_weight_desc_list1 = font_family_detailed[index_description].variants
        var font_weight_desc_list = []
        for (var i = 0; i < font_weight_desc_list1.length; i++) {
            font_weight_desc_list.push({ label: font_weight_desc_list1[i], value: font_weight_desc_list1[i] })
        }
    
    

        const mbdescrresepx = () =>{
            var x = document.getElementById("mbdescrresepx");
            var y = document.getElementById("mbdescrreseem");
            x.style.textDecoration ="underline";
            y.style.textDecoration ="none";
            props.setAttributes({mbdescriptionempx: 'px'})
        }
        const mbdescrreseem = () =>{
            var x = document.getElementById("mbdescrresepx");
            var y = document.getElementById("mbdescrreseem");
            x.style.textDecoration ="none";
            y.style.textDecoration ="underline";
            props.setAttributes({mbdescriptionempx: 'em'})
        }
    


        const changeBackground = (e) => {
            e.target.style.backgroundColor = props.attributes.bg_hover_color
        }
        const sameColor = (e) => {
            e.target.style.backgroundColor = props.attributes.bg_color
        };
        const changeTitle = (e) => {
            e.target.style.color = props.attributes.hover_title_color
        }
        const sameTitle = (e) => {
            e.target.style.color = props.attributes.title_color
        };
        const changeIcon = (e) => {
            e.target.style.color = props.attributes.hover_icon_color
        }
        const sameIcon = (e) => {
            e.target.style.color = props.attributes.icon_color
        };
        const changeDesc = (e) => {
            e.target.style.color = props.attributes.hover_desc_color
        }
        const sameDesc = (e) => {
            e.target.style.color = props.attributes.description_color
        };
        const btn_background = (val) => {
            var x = document.getElementById("bg1");
            var y = document.getElementById("bg2");
            var z = document.getElementById("bg3");
      

            if (val === "transparent") {
            props.setAttributes({gradient_bg:"transparent"})
                x.style.display = "none";
                z.style.display = "none";
                y.style.display = 'none'

            } else if (val === 'color') {
                props.setAttributes({bg_color:props.attributes.bg_color})         
                props.setAttributes({gradient_bg:props.attributes.bg_color})
                x.style.display = 'block'
                y.style.display = 'block'
                z.style.display = 'none'

            }
            else if (val === 'gradient') {
                props.setAttributes({bg_color:props.attributes.gradient_bg})
                props.setAttributes({gradient_bg:props.attributes.gradient_bg})
                z.style.display = 'block'
                y.style.display = 'none'
                x.style.display = 'block'
            }
        };
        const position_icon = (val) => {
            if (val === "before") {
                props.setAttributes({ iconDisp1: 'block' })
                props.setAttributes({ iconDisp2: 'none' })
            } else if ((val === "after")) {
                props.setAttributes({ iconDisp1: 'none' })
                props.setAttributes({ iconDisp2: 'block' })
            }
        };
        const border_setting = (val) => {
            var x = document.getElementById('border_setting')
            if (val === 'None') {
                x.style.display = 'none'
            }
            else if (val === 'Solid' || val === 'Dotted' || val === 'Dashed' || val === 'Double' || val === 'Groove' || val === 'Inset' || val === 'Outset' || val === 'Ridge') {
                x.style.display = 'block'
            }
        }

        const px_padding = () => {
            props.setAttributes({padding_lrtp:"px"})  
        }
        const pc_padding = () => {
            props.setAttributes({padding_lrtp:"%"})
        }
        const title_body = () => {
            var x = document.getElementById("title_body");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
        const reset_body = () => {
            props.setAttributes({ title_size: 24 })
            props.setAttributes({ title_font_family: 'ABeeZee' })
            props.setAttributes({ title_line_height: 1.5 })
            props.setAttributes({ title_weight: 'regular' })
        }
        const px_title = () => {
            var x  = document.getElementById("title_fpx");
            var y  = document.getElementById("title_fem");
            x.style.textDecoration="underline";
            y.style.textDecoration="none";
           props.setAttributes({pxemtitlte:'px'})
        }
        const em_title = () => {
            props.setAttributes({pxemtitlte:'em'})
            var x  = document.getElementById("title_fpx");
            var y  = document.getElementById("title_fem");
            x.style.textDecoration="none";
            y.style.textDecoration="underline";
        }
        const desc_body = () => {
            var x = document.getElementById("desc_body");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
        const reset_desc = () => {
            props.setAttributes({ description_size: 16 })
            props.setAttributes({ description_font_family: 'ABeeZee' })
            props.setAttributes({ description_line_height: 1.5 })
            props.setAttributes({ description_weight: 'regular' })
        }
        const px_desc = () => {
            var px_desc = document.getElementById("px_desc");
            var em_desc = document.getElementById("em_desc");
            px_desc.style.textDecoration="underline";
            em_desc.style.textDecoration="none";
          props.setAttributes({mbdescempx: 'px'})
        }
        const em_desc = () => {
            var px_desc = document.getElementById("px_desc");
            var em_desc = document.getElementById("em_desc");
            px_desc.style.textDecoration="none";
            em_desc.style.textDecoration="underline";
            props.setAttributes({mbdescempx: 'em'})
        }

        const mlinheighttitlepx = () => {
            var x = document.getElementById("mlinheighttitlepx");
            var y = document.getElementById("mlinheighttitleem");
            x.style.textDecoration="underline";
            y.style.textDecoration="none";

            props.setAttributes({LneHghttitlepx: 'px'})
        }
        
        const mlinheighttitleem = () => {
            var x = document.getElementById("mlinheighttitlepx");
            var y = document.getElementById("mlinheighttitleem");
            x.style.textDecoration="none";
            y.style.textDecoration="underline";
            props.setAttributes({LneHghttitlepx: 'em'})
        }
        return [
            <div>
                <InspectorControls>
                    <PanelBody title={__('General', 'blocks-bakery')} initialOpen={true}>
                        <SelectControl
                            label="Text Alignment"
                            options={[
                                { label: 'Right', value: 'flex-end' },
                                { label: 'Left', value: 'flex-start' },
                                { label: 'Center', value: 'center' },
                            ]}
                            value={props.attributes.position_div}
                            onChange={(new_val) => {
                                props.setAttributes({ position_div: new_val })
                            }}
                        />
                        <hr />
                        <h2>Button Icon</h2>
                      
                        <IconPicker
                            allowReset={false}
                            value={props.attributes.icon_selector}
                       
                            onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                   />
                       
                        <SelectControl
                            label="Icon Position"
                            options={[
                                { label: 'Before Text', value: 'before' },
                                { label: 'After Text', value: 'after' },
                            ]}
                            value={props.attributes.position_icon}
                            onChange={(new_val) => {
                                props.setAttributes({ position_icon: new_val })
                                position_icon(new_val)
                            }}
                         
                        />
                        <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            label="Icon Spacing"
                            min={0}
                            max={50}
                            initialPosition={5}
                            value={props.attributes.icon_spacing}
                            onChange={(new_val) => {
                                props.setAttributes({ icon_spacing: new_val })
                            }}
                        />
                        </div>
                        <Button style={{
                                    background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"}}
                                    onClick={() => {
                                        props.setAttributes({icon_spacing:5})
                                    }}> Reset 
                        </Button>
                        </div>

                        <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            label="Title Bottom Margin"      
                            min={0}
                            max={20}
                            initialPosition={0}
                            value={props.attributes.bt_margin}
                            onChange={(new_val) => {
                                props.setAttributes({ bt_margin: new_val })
                            }}
                        />
                        </div>
                        <Button style={{
                                    background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"}}
                                    onClick={() => {
                                        props.setAttributes({bt_margin:0})
                                    }}> Reset 
                        </Button>
                        </div>

                        <p>URL</p>
                        <TextControl
                            value={props.attributes.url_icon}
                            onChange={(new_val) => {
                                props.setAttributes({ url_icon: new_val })
                            }} />
                       
                    </PanelBody>
                    <PanelBody title={__('Content', 'blocks-bakery')} initialOpen={false}>
                        <SelectControl
                            label={__("Title Tag", "blocks_bakery")}
                            value={props.attributes.title_tag}
                            options={[
                                { label: 'h1', value: 'h1' },
                                { label: 'h2', value: 'h2' },
                                { label: 'h3', value: 'h3' },
                                { label: 'h4', value: 'h4' },
                                { label: 'h5', value: 'h5' },
                                { label: 'h6', value: 'h6' },
                                { label: 'Span', value: 'span' },
                                { label: 'P', value: 'p' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ title_tag: new_val })
                            }} />
                        <hr />
                        <h2>Title</h2>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button style={{ padding: '0px' }}><span><Dashicon icon="image-rotate" style={{ fontSize: '15px', marginTop: '-5px' }} onClick={reset_body} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: '15px', marginTop: '-5px' }} onClick={title_body} /></span></Button>
                            </div>
                        </PanelRow>

                        {/* card body start */}
                        <Card id="title_body" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={px_title} id="title_fpx"  style={{ textDecoration:"underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={em_title} id="title_fem" style={{  fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl                       
                                            beforeIcon="editor-textcolor"
                                            initialPosition={24}
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            onChange={(new_val) => {
                                                props.setAttributes({ title_size: new_val })
                                            }}
                                            value={props.attributes.title_size}
                                        />
                                        </div>

                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({title_size:24})
                                            }}> Reset 
                                        </Button>

                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ title_font_family: new_val })
                                        }}
                                        value={props.attributes.title_font_family}
                                    />

                                    <SelectControl
                                        label="Font Weight"
                                        options={font_weight_title_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ title_weight: new_val })
                                        }}
                                        value={props.attributes.title_weight}
                                    />
                                  <div >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 35 }}>Line Height</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>

                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>

                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={mlinheighttitlepx} id="mlinheighttitlepx" style={{  fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={mlinheighttitleem} id="mlinheighttitleem"  style={{ textDecoration: "underline", fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>

                                </div>
                                    <div className="range-controler" style={{display:"flex"}}>       
                                        <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        
                                        beforeIcon="editor-textcolor"
                                        initialPosition={1.5}
                                        min={0}
                                        max={100}
                                        step={0.1}
                                        onChange={(new_val) => {
                                            props.setAttributes({ title_line_height: new_val })
                                        }}
                                        value={props.attributes.title_line_height}
                                    />
                                    </div>
                                    <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                             var reset_heading=document.getElementsByClassName("marketing-button-main-heading")[0];
                                           
                                            props.setAttributes({title_line_height:1.5})
                                            }}> Reset 
                                        </Button>

                                    </div>
                                </div>
                                
                            </div>
                                    
                            </CardBody>
                        </Card>
                        <hr />
                        <h2>Description</h2>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button style={{ padding: '0px' }}><span><Dashicon icon="image-rotate" style={{ fontSize: '15px', marginTop: '-5px' }} onClick={reset_desc} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: '15px', marginTop: '-5px' }} onClick={desc_body} /></span></Button>
                            </div>
                        </PanelRow>

                        {/* card body start */}
                        <Card id="desc_body" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={px_desc} id="px_desc" style={{textDecoration:"underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={em_desc} id="em_desc" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl     
                                            beforeIcon="editor-textcolor"
                                            initialPosition={16}
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            onChange={(new_val) => {
                                                props.setAttributes({ description_size: new_val })
                                            }}
                                            value={props.attributes.description_size}
                                        />
                                        </div>
                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({description_size:16})
                                            }}> Reset 
                                        </Button>
                                        
                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ description_font_family: new_val })
                                        }}
                                        value={props.attributes.description_font_family}
                                    />

                                    <SelectControl
                                        label="Font Weight"
                                     options={font_weight_desc_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ description_weight: new_val })
                                        }}
                                        value={props.attributes.description_weight}
                                    />

                                    <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 35 }}>Line Height</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>

                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>

                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={mbdescrresepx} id="mbdescrresepx" style={{fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={mbdescrreseem} id="mbdescrreseem" style={{textDecoration: "underline",fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>

                                </div>
                                <div className="range-controler" style={{display:"flex"}}>             
                                        <div style={{marginRight:"10px",width:"100%"}}>
                                   
                                    <RangeControl   
                                        beforeIcon="editor-textcolor"
                                        initialPosition={1.5}
                                        min={0}
                                        max={100}
                                        step={0.1}
                                        onChange={(new_val) => {
                                            props.setAttributes({ description_line_height: new_val })
                                        }}
                                        value={props.attributes.description_line_height}
                                    />
                                </div>  
                                <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({description_line_height:1.5})
                                            }}> Reset 
                                        </Button>
                                        </div>
                                        </div>
                            </CardBody>
                        </Card>
                        <hr />
                        <h2>Colors</h2>
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: 'Normal',
                                    title: 'Title Color',
                                    className: <ColorPalette
                                    colors={color_palette_list}
                                        value={props.attributes.title_color}
                                        onChange={(new_val) => {
                                            props.setAttributes({ title_color: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.title_color} />

                                },

                                {
                                    name: 'Hover',
                                    title: 'Title Hover',
                                    className: <ColorPalette
                                    colors={color_palette_list}
                                        value={props.attributes.hover_title_color}
                                        onChange={(new_val) => {
                                            props.setAttributes({ hover_title_color: new_val })
                                        }}

                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.hover_title_color} />

                                },
                            ]}>
                            {
                                (tab) => <div>
                                    <br />
                                    <p>{tab.value} {tab.title}</p>
                                    <p>{tab.className}</p>
                                </div>
                            }
                        </TabPanel>
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: 'Normal',
                                    title: 'Icon Color',
                                    className: <ColorPalette

                                    colors={color_palette_list}
                                        value={props.attributes.icon_color}
                                        onChange={(new_val) => {
                                            props.setAttributes({ icon_color: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.icon_color} />

                                },

                                {
                                    name: 'Hover',
                                    title: 'Icon Hover',
                                    className: <ColorPalette
                                    colors={color_palette_list}
                                        value={props.attributes.hover_icon_color}
                                        onChange={(new_val) => {
                                            props.setAttributes({ hover_icon_color: new_val })
                                        }}

                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.hover_icon_color} />

                                },
                            ]}>
                            {
                                (tab) => <div>
                                    <br />
                                    <p>{tab.value} {tab.title}</p>
                                    <p>{tab.className}</p>
                                </div>
                            }
                        </TabPanel>
                        <TabPanel className="my-tab-panel"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: 'Normal',
                                    title: 'Description Color',
                                    className: <ColorPalette
                                    colors={color_palette_list}
                                        value={props.attributes.description_color}
                                        onChange={(new_val) => {
                                            props.setAttributes({ description_color: new_val })
                                        }}
                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.description_color} />

                                },

                                {
                                    name: 'Hover',
                                    title: 'Description Hover',
                                    className: <ColorPalette
                                    colors={color_palette_list}
                                        value={props.attributes.hover_desc_color}
                                        onChange={(new_val) => {
                                            props.setAttributes({ hover_desc_color: new_val })
                                        }}

                                    />,
                                    value: <ColorIndicator colorValue={props.attributes.hover_desc_color} />

                                },
                            ]}>
                            {
                                (tab) => <div>
                                    <br />
                                    <p>{tab.value} {tab.title}</p>
                                    <p>{tab.className}</p>
                                </div>
                            }
                        </TabPanel>
                  
                    </PanelBody>
                    <PanelBody title={__('Background & Spacing', 'blocks-bakery')} initialOpen={false}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <h2 style={{ marginRight: 35 }}>Button Padding</h2>
                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                            <Button onClick={px_padding} id="px_padding" primaray style={{ textDecoration: "underline", fontSize: 12, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                            <Button onClick={pc_padding} id="pc_padding" primaray style={{fontSize: 12, padding: 0 }}><span style={{ height: 30 }}>%</span></Button>
                        </div>

                        <div className="range-controler">   
                        <RangeControl
                            beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.016 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.103 0 2-0.896 2-2z"></path><path fill="#575E67" d="M0.968 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                            initialPosition={100}
                            min={0}
                            max={2000}
                            step={0.1}
                            onChange={(new_val) => {
                                props.setAttributes({ padding_lf_rh: new_val })
                            }}
                            value={props.attributes.padding_lf_rh}
                        />
                        </div>

                        <div className="range-controler">
                        <RangeControl
                         beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.656-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.983h-14c-1.103 0-2 0.896-2 2v0.797h18v-0.797c0-1.103-0.896-2-2-2z"></path><path fill="#575E67" d="M3 19.031h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.104 0.896 2 2 2z"></path></svg>}
                            initialPosition={20}
                            min={0}
                            max={2000}
                            step={0.1}
                            onChange={(new_val) => {
                                props.setAttributes({ padding_topbottom: new_val })
                            }}
                            value={props.attributes.padding_topbottom}
                        />
                        </div>

                        <hr />
                        <h2>Button Background</h2>

                        <SelectControl
                            label="Background Type"
                            options={[
                                { label: 'Transparent', value: 'transparent' },
                                { label: 'Color', value: 'color' },
                                { label: 'Gradient', value: 'gradient' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ bg_content: new_val })
                                btn_background(new_val)
                            }}
                            value={props.attributes.bg_content}
                        />
                        <div id='bg1' style={{ display: "none" }}>
                            <div id='bg2' style={{ display: "block" }}>
                                <p><span>{__('Background Color', 'blocks-bakery')}
                                    <ColorIndicator style={{ backgroundColor: props.attributes.bg_color }} />
                                </span></p>
                                <ColorPalette
                               colors={color_palette_list}
                                    value={props.attributes.bg_color}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bg_color: new_val })
                                    }}
                                />
                                
                                <div className="range-controler" style={{display:"flex"}}>
                                <div style={{marginRight:"10px",width:"100%"}}>
                                <RangeControl
                                    label={__('Opacity', 'blocks-bakery')}
                                    min={0}
                                    max={1}
                                    value={props.attributes.bg_color_opacity}
                                    step={0.1}
                                    initialPosition={1}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bg_color_opacity: new_val })
                                    }} />
                                 </div>  
                                <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({bg_color_opacity:1})
                                            }}> Reset 
                                        </Button>
                                </div>
                               
                                {/* <p><span>{__('Background Hover Color', 'blocks-bakery')}
                            <ColorIndicator style={{ backgroundColor: props.attributes.bg_hover_color }} />
                            </span></p>
                            <ColorPalette
                                colors={[
                                    { name: "red", color: "red" },
                                    { name: "green", color: "green" },
                                    { name: "blue", color: "blue" },
                                    { name: "yellow", color: "yellow" },
                                    { name: "pink", color: "pink" },
                                    { name: "white", color: "white" },
                                    { name: "gray", color: "gray" },
                                    { name: "black", color: "black" },
                                    { name: "lightblue", color: "lightblue" },
                                    { name: "cyan", color: "cyan" },
                                ]}
                                value={props.attributes.bg_hover_color}
                                onChange={(new_val) => {
                                    props.setAttributes({ bg_hover_color: new_val })
                                }}
                            /> */}
                                {/* <RangeControl
                                label={__('Opacity', 'blocks-bakery')}
                                min={0}
                                max={100}
                                value={props.attributes.hover_opacity}
                                allowReset={true}
                                initialPosition={100}
                                onChange={(new_val) => {
                                    props.setAttributes({ hover_opacity: new_val })
                                }} /> */}
                            </div>
                            <div id='bg3'>
                               
                                  <__experimentalGradientPicker
                                    value={props.attributes.gradient_bg}
                                    onChange={(new_val) => {
                                        props.setAttributes({ gradient_bg: new_val })
                                      
                                    }} 
                                    />
                            </div>
                        </div>
                    </PanelBody>

                    <PanelBody title={__('Border', 'blocks-bakery')} initialOpen={false}>
                        <SelectControl
                            label={__('Border Style', 'blocks-bakery')}
                            value={props.attributes.select_border}
                            options={[
                                { value: 'None', label: 'None' },
                                { value: 'solid', label: 'Solid' },
                                { value: 'dotted', label: 'Dotted' },
                                { value: 'dashed', label: 'Dashed' },
                                { value: 'double', label: 'Double' },
                                { value: 'groove', label: 'Groove' },
                                { value: 'inset', label: 'Inset' },
                                { value: 'outset', label: 'Outset' },
                                { value: 'ridge', label: 'Ridge' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ select_border: new_val })
                                border_setting(new_val)
                            }}
                        />
                        <div id='border_setting'>
                        <div className="range-controler"  style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                            <RangeControl
                                label={__('Border Width', 'blocks-bakery')}
                                min={0}
                                max={50}
                                value={props.attributes.border_width}
                                initialPosition={1}
                                onChange={(new_val) => {
                                    props.setAttributes({ border_width: new_val })
                                }} />
                                </div>
                                <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba", marginTop:"25px"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({border_width:1})
                                            }}> Reset 
                                        </Button>
                                </div>

                        <div className="range-controler"  style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                            <RangeControl
                                label={__('Border Radius', 'blocks-bakery')}
                                min={0}
                                max={500}
                                value={props.attributes.border_radius}
                                initialPosition={0}
                                onChange={(new_val) => {
                                    props.setAttributes({ border_radius: new_val })
                                }} />
                                 </div>
                                <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba", marginTop:"25px"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({border_radius:0})
                                            }}> Reset 
                                        </Button>
                                </div>
                            <p>Border Color<span>
                                <ColorIndicator
                                    style={{ backgroundColor: props.attributes.border_color }} /></span></p>
                            <ColorPalette
                            colors={color_palette_list}
                                value={props.attributes.border_color}
                                onChange={(new_val) => {
                                    props.setAttributes({ border_color: new_val })
                                }}
                            />
                        </div>
                        {/* <p>Border Hover Color<span>
                        <ColorIndicator
                            style={{ backgroundColor: props.attributes.border_hover_color }} /></span></p>
                    <ColorPalette
                        colors={[
                            { name: "red", color: "red" },
                            { name: "green", color: "green" },
                            { name: "blue", color: "blue" },
                            { name: "yellow", color: "yellow" },
                            { name: "pink", color: "pink" },
                            { name: "white", color: "white" },
                            { name: "gray", color: "gray" },
                            { name: "black", color: "black" },
                            { name: "lightblue", color: "lightblue" },
                            { name: "cyan", color: "cyan" },
                        ]}
                        value={props.attributes.border_hover_color}
                        onChange={(new_val) => {
                            props.setAttributes({ border_hover_color: new_val })
                        }}
                    /> */}
                    </PanelBody>
                </InspectorControls>
                <BlockControls>
                    <BlockAlignmentToolbar
                        value={props.attributes.block_alignment}
                        onChange={(new_val) => {
                            props.setAttributes({ block_alignment: new_val })
                            if(new_val==="full"){
                                props.setAttributes({width_adjust:"initial"})
                            }
                            else{
                                props.setAttributes({width_adjust:"fit-content"})
                            }
                        }} />
                </BlockControls>
              
                <div align={props.attributes.block_alignment} className={props.className} >
                    <div className='main_div' style={{
                        width:props.attributes.width_adjust,
                        border: props.attributes.select_border, borderWidth: props.attributes.border_width,
                        borderRadius: props.attributes.border_radius, borderColor: props.attributes.border_color, background: props.attributes.gradient_selector + '(' + props.attributes.angle + 'deg' + ',' + props.attributes.color1 + ' ' + props.attributes.location1 + '%' + ',' + props.attributes.color2 + " " + props.attributes.location2 + '%' + ')',
                        backgroundColor: props.attributes.bg_color,
                        background:props.attributes.gradient_bg, 
                         opacity: props.attributes.bg_color_opacity,   
                         paddingLeft: props.attributes.padding_lf_rh + props.attributes.padding_lrtp,
                         paddingRight: props.attributes.padding_lf_rh + props.attributes.padding_lrtp,
                          paddingTop: props.attributes.padding_topbottom + props.attributes.padding_lrtp, 
                          paddingBottom: props.attributes.padding_topbottom + props.attributes.padding_lrtp,
                    }} >
                        <div style={{ display: 'flex', justifyContent: props.attributes.position_div,  marginBottom: props.attributes.bt_margin }} >

                            <span onMouseOver={changeIcon} onMouseLeave={sameIcon} className={props.attributes.icon_selector} id='before' style={{
                                display: props.attributes.iconDisp1,
                                fontSize: props.attributes.icon_size,
                                marginRight: props.attributes.icon_spacing, color: props.attributes.icon_color
                            }} ></span>
                            <a href={props.attributes.url_icon} style={{ textDecoration: 'none' }}>
                                <RichText
                                    onMouseOver={changeTitle} onMouseLeave={sameTitle}
                                    id='reset_body'
                                    className="marketing-button-main-heading"
                                    style={{
                                        fontSize: props.attributes.title_size + props.attributes.pxemtitlte,
                                         fontFamily: props.attributes.title_font_family,
                                        fontWeight: props.attributes.title_weight,
                                         lineHeight: props.attributes.title_line_height + props.attributes.LneHghttitlepx,
                                          color: props.attributes.title_color,
                                        maxWidth: '500px',
                                         marginLeft: '10px',
                                          marginRight: '10px',
                                           marginTop: '0px',
                                            marginBottom: '0px'
                                    }}
                                    tagName={props.attributes.title_tag}
                                    value={props.attributes.title_value}
                                    onChange={(new_val) => {
                                        props.setAttributes({ title_value: new_val })
                                    }}
                                />
                            </a>
                            <span onMouseOver={changeIcon} onMouseLeave={sameIcon} className={props.attributes.icon_selector}  style={{
                                display: props.attributes.iconDisp2, fontSize: "30px",
                                marginLeft: props.attributes.icon_spacing, color: props.attributes.icon_color
                            }} ></span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: props.attributes.position_div}}>
                            <RichText
                                onMouseOver={changeDesc} onMouseLeave={sameDesc}
                                id='reset_desc'
                                className="marketing-button-bb"
                                style={{
                                    fontSize: props.attributes.description_size + props.attributes.mbdescempx,
                                    fontWeight: props.attributes.description_weight,
                                    fontFamily: props.attributes.description_font_family, 
                                    lineHeight: props.attributes.description_line_height  + props.attributes.mbdescriptionempx,
                                    margin: '0px', color: props.attributes.description_color
                                }}
                                tagName='p'
                                value={props.attributes.paragraph_value}
                                onChange={(new_val) => {
                                    props.setAttributes({ paragraph_value: new_val })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        ]

    },

    save: (props) => {
        const changeTitle = (e) => {
            e.target.style.color = props.attributes.hover_title_color
        }
        const sameTitle = (e) => {
            e.target.style.color = props.attributes.title_color
        };
        const changeIcon = (e) => {
            e.target.style.color = props.attributes.hover_icon_color
        }
        const sameIcon = (e) => {
            e.target.style.color = props.attributes.icon_color
        };
        const changeDesc = (e) => {
            e.target.style.color = props.attributes.hover_desc_color
        }
        const sameDesc = (e) => {
            e.target.style.color = props.attributes.description_color
        };
        return (
            <div align={props.attributes.block_alignment} className={props.className}>
                <div className='main_div' style={{
                    width:props.attributes.width_adjust,
                   border: props.attributes.select_border, borderWidth: props.attributes.border_width,
                    borderRadius: props.attributes.border_radius,
                     borderColor: props.attributes.border_color, 
                     backgroundColor: props.attributes.bg_color,
                     background:props.attributes.gradient_bg,
                    opacity: props.attributes.bg_color_opacity, 
                    // marpaginLeft: props.attributes.margin_lf_rh, 
                    // marginRight: props.attributes.margin_lf_rh,
                     paddingLeft: props.attributes.padding_lf_rh + props.attributes.padding_lrtp,
                    paddingRight: props.attributes.padding_lf_rh + props.attributes.padding_lrtp,
                     paddingTop: props.attributes.padding_topbottom + props.attributes.padding_lrtp, 
                     paddingBottom: props.attributes.padding_topbottom+ props.attributes.padding_lrtp,
                }} >
                    <div style={{ display: 'flex', justifyContent: props.attributes.position_div, marginBottom: props.attributes.bt_margin }} >

                        <span onMouseOver={changeIcon} onMouseLeave={sameIcon} className={props.attributes.icon_selector} id='before' style={{
                            display: props.attributes.iconDisp1,
                            fontSize: props.attributes.icon_size,
                            marginRight: props.attributes.icon_spacing, color: props.attributes.icon_color
                        }} />
                        <a href={props.attributes.url_icon} style={{ textDecoration: 'none' }}>
                            <RichText.Content
                                onMouseOver={changeTitle} onMouseLeave={sameTitle}
                                id='reset_body'
                                className="marketing-button-main-heading"
                                style={{
                                    fontSize: props.attributes.title_size + props.attributes.pxemtitlte,
                                    
                                    
                                    fontFamily: props.attributes.title_font_family,
                                    fontWeight: props.attributes.title_weight, 
                                    lineHeight: props.attributes.title_line_height + props.attributes.LneHghttitlepx,
                                    color: props.attributes.title_color,
                                    maxWidth: '500px', 
                                    marginLeft: '10px', 
                                    marginRight: '10px', 
                                    marginTop: '0px', 
                                    marginBottom: '0px'
                                }}
                                tagName={props.attributes.title_tag}
                                value={props.attributes.title_value}
                            />
                        </a>
                        <span onMouseOver={changeIcon} onMouseLeave={sameIcon} className={props.attributes.icon_selector} style={{
                            display: props.attributes.iconDisp2, fontSize: "30px",
                            marginLeft: props.attributes.icon_spacing, color: props.attributes.icon_color
                        }} ></span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: props.attributes.position_div}}>
                        <RichText.Content
                            onMouseOver={changeDesc} onMouseLeave={sameDesc}
                            id='reset_desc'
                            className="marketing-button-bb"
                            style={{
                                fontSize: props.attributes.description_size + props.attributes.mbdescempx, 
                                fontWeight: props.attributes.description_weight,
                                fontFamily: props.attributes.description_font_family,
                                lineHeight: props.attributes.description_line_height + props.attributes.mbdescriptionempx,
                                margin: '0px', color: props.attributes.description_color
                            }}
                            tagName='p'
                            value={props.attributes.paragraph_value}
                        />
                    </div>
                </div>
            </div>
        )
    }
})